export default __webpack_public_path__ + "static/media/5.ff96bc54.jpg";